<template>
  <div class="footer-bottom-container">
    <div class="footer-bottom-con">
      <span>版权所有©1996-2021 天津市旅游（控股）集团有限公司</span>
      <span>
        <span class="jicon"></span>
        津公网安备 12010302001487号
      </span>
      <span
        ><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
          >津ICP备13005272号-1</a
        ></span
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      view: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getHomeView();
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    getHomeView() {
      axios.get("/jtg/home/view").then((result) => {
        let res = JSON.parse(JSON.stringify(result.data));
        this.view = res.data;
        // console.log(res.data, 7777);
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.footer-bottom-container{
  background-color: #272C37;
  overflow: hidden;
}
.footer-bottom-con {
  border-top: 1px solid #FFFFFF66;
  width: 1600px;
  height: 110px;
  line-height: 110px;
  margin: 0 auto;
  text-align: center;
}
.footer-bottom-con span {
  &,a {
    text-decoration: none;
    font-size: 16px;
    color: #fff;
    padding-right: 10px;
    letter-spacing: 0.02em;
  }
}
.fwl {
  margin-left: 140px;
}
</style>